import { render, staticRenderFns } from "./PersonBook1.vue?vue&type=template&id=5f2ecced&scoped=true&"
import script from "./PersonBook1.vue?vue&type=script&lang=js&"
export * from "./PersonBook1.vue?vue&type=script&lang=js&"
import style0 from "./PersonBook1.vue?vue&type=style&index=0&id=5f2ecced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ecced",
  null
  
)

export default component.exports